<template>

<app-wrapper v-if="is.loaded">

	<com-transitions />
	<com-cta />
	<com-adverts />
	<com-recent />

</app-wrapper>

</template>

<script>

import mixinPage from '@/mixin/page.js'

import comTransitions from './home/Transitions'
import comCTA from './home/CTA'
import comAdverts from './home/Adverts'
import comRecent from './home/Recent'

export default {

    mixins: [mixinPage],
    
    components: {
        'com-transitions': comTransitions,
        'com-cta': comCTA,
        'com-adverts': comAdverts,
        'com-recent': comRecent
    }

}

</script>

<style scoped>

</style>
